import React from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import {createStructuredSelector} from 'reselect'

import * as cross from '../../../store/cross'
import * as pdp from '../../../store/productDetailPage'

function SoldOutModalDetails(props) {
  const productName = props.displayedProduct.name
  return (
    <div>
      <h1 className="modal-header">This item is sold out.</h1>
      <p className="modal-text">
        We’re sorry — {props.isOutfit ? null : 'the'} {productName} is unavailable for events
        between &nbsp;{props.soldOutPeriodForRent}.
      </p>
      <p className="modal-text">We have plenty of other styles available for your event.</p>
    </div>
  )
}

SoldOutModalDetails.propTypes = {
  displayedProduct: PropTypes.oneOfType([PropTypes.bool, PropTypes.shape({})]),
  isOutfit: PropTypes.bool.isRequired,
  soldOutPeriodForRent: PropTypes.string.isRequired,
}

const mapStateToProps = createStructuredSelector({
  displayedProduct: pdp.product,
  isOutfit: pdp.productIsOutfit,
  soldOutPeriodForRent: cross.soldOutPeriodForRent,
})

export default connect(mapStateToProps)(SoldOutModalDetails)
